export default {"src":"/_next/static/media/configuration-hardening.6229f85c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};